import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { environment } from 'src/environments/environment';
import { ArticalsService } from '../../articals/articals.service';
import { ProfileService } from '../../profile/profile.service';
import { ArticalManagementService } from '../artical-management.service';
import { ModalArticalPreviewComponent } from '../modal-artical-preview/modal-artical-preview.component';
import { LearningCenterService } from '../../learning-center/learning-center.service';

@Component({
  selector: 'app-manage-artical',
  templateUrl: './manage-artical.component.html',
  styleUrls: ['./manage-artical.component.scss']
})
export class ManageArticalComponent implements OnInit {
  articalHeader: string;
  articalForm: FormGroup;
  pollForm: FormGroup;
  articalFormEdit: FormGroup;
  dialogConfig = new MatDialogConfig();
  articalData = null;
  dateTime = [];
  dateTimePoll = [];
  coverName: string = null;
  coverUrl: string = null;
  category;
  profile;
  isLoading: boolean = false;
  isEdit: boolean;
  havePoll: boolean = false;
  articalId: string;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '500px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '100%',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentArtical',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  allLearningCenter: any[] = [];
  learningCenter: any;

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private profileService: ProfileService,
    private articalsService: ArticalsService,
    private articalManagementService: ArticalManagementService,
    private gobalFunctionService: GobalFunctionService,
    private learningCenterService: LearningCenterService,
  ) { }

  ngOnInit(): void {
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.articalId = new URL(location.href).searchParams.get('article_id');

    if (!this.isEdit) {
      this.gobalFunctionService.setTitle('สร้างบทความ');
      this.articalForm = this.fb.group({
        articalTital: ['', Validators.required],
        articalCover: ['', Validators.required],
        articalCategory: ['', Validators.required],
        articalDate: [''],
        articalAlwaysOpen: [''],
        articalContent: ['', Validators.required],
        centerId: [''],
      })

      this.pollForm = this.fb.group({
        pollQuestion: ['', Validators.required],
        pollTime: ['', Validators.required],
        pollChoice1: ['', Validators.required],
        pollChoice2: ['', Validators.required]
      })
    } else {
      this.gobalFunctionService.setTitle('แก้ไขบทความ');
    }

    this.profileService.getProfile().pipe(
      switchMap(profile => {
        this.profile = profile.result;
        return this.articalManagementService.getCategoryArtical()
      }),
      map(category => {
        this.category = category.result
      })
    ).subscribe();


    if ((this.isEdit && this.articalId)) {
      this.articalsService.getDetailByArticalID(this.articalId).pipe(
        map(res => {
          this.articalData = res.result;
          console.log(this.articalData);

          if (this.articalData.DETAIL_POLL.length > 0) {
            if (this.articalData.DETAIL_POLL[0].POLL_STATUS === 1) {
              this.havePoll = false;
            } else {
              this.havePoll = true;
            }
            this.dateTimePoll[0] = new Date(this.articalData.DETAIL_POLL[0].POLL_START);
            this.dateTimePoll[1] = new Date(this.articalData.DETAIL_POLL[0].POLL_END);

            this.pollForm = this.fb.group({
              pollQuestion: [this.articalData.DETAIL_POLL[0].POLL_QUESTION, Validators.required],
              pollTime: [this.dateTimePoll, Validators.required],
              pollChoice1: [this.articalData.DETAIL_POLL[0].POLL_CHOICE[0].OPTION_VALUE, Validators.required],
              pollChoice2: [this.articalData.DETAIL_POLL[0].POLL_CHOICE[1].OPTION_VALUE, Validators.required]
            })
          } else {
            this.pollForm = this.fb.group({
              pollQuestion: ['', Validators.required],
              pollTime: ['', Validators.required],
              pollChoice1: ['', Validators.required],
              pollChoice2: ['', Validators.required]
            })

            this.havePoll = false;
          }

          this.articalFormEdit = this.fb.group({
            articalTital: ['', Validators.required],
            articalCover: [''],
            articalCategory: ['', Validators.required],
            articalDate: [''],
            articalAlwaysOpen: [''],
            articalContent: ['', Validators.required],
            centerId: [''],
          })

          if (this.articalData.DETAIL_ARTICAL[0].ALWAYS_OPEN == 'true') {
            this.articalFormEdit['articalAlwaysOpen'] = true;
            this.articalData.DETAIL_ARTICAL[0].ALWAYS_OPEN = true;
            this.dateTime = null;
          } else {
            this.articalFormEdit['articalAlwaysOpen'] = false;
            this.articalData.DETAIL_ARTICAL[0].ALWAYS_OPEN = false;
            this.dateTime[0] = new Date(this.articalData.DETAIL_ARTICAL[0].ARTICAL_START);
            this.dateTime[1] = new Date(this.articalData.DETAIL_ARTICAL[0].ARTICAL_END);
          }

          if (this.articalData.DETAIL_ARTICAL[0].ARTICAL_ORIGINAL !== '') {
            this.coverName = this.articalData.DETAIL_ARTICAL[0].ARTICAL_ORIGINAL;
            this.coverUrl = this.articalData.DETAIL_ARTICAL[0].ARTICAL_PIC
          }
        })
      ).subscribe()
    } else {
      this.articalForm['articalAlwaysOpen'] = false;
    }

    this.getAllLearning();
  }

  preview(articalForm, isEdit, pollForm?) {
    // console.log(pollForm);

    if (!articalForm.articalDate && !articalForm.articalAlwaysOpen) {
      alert('กรุณาใส่ เวลาเปิด / ปิดข่าว')
    } else {
      if (!articalForm.articalCover && this.coverName) {
        this.articalHeader = this.coverUrl;
        articalForm['articalCover'] = this.coverUrl;
      }

      if (articalForm.articalAlwaysOpen) {
        articalForm['articalAlwaysOpen'] = 'true'
      } else {
        articalForm['articalAlwaysOpen'] = 'false'
      }

      this.dialogConfig.disableClose = true;
      this.dialogConfig.id = 'modalAddArtical';
      this.dialogConfig.width = '60%'

      if (this.isEdit) {
        this.dialogConfig.data = {
          title: 'Preview : ' + articalForm.articalTital,
          isEdit: isEdit,
          actionBtnText: 'บันทึกและเผยแพร่',
          cancleBtnText: 'ย้อนกลับ',
          customStyle: 'min-width: 650px;',
          articalForm: articalForm,
          havePoll: this.havePoll,
          pollForm: pollForm ? pollForm : this.articalData?.DETAIL_POLL[0],
          pollStatus: this.articalData.DETAIL_POLL[0]?.POLL_STATUS,
          pollOptionIds: this.articalData.DETAIL_POLL[0]?.POLL_CHOICE,
          articalHeader: this.articalHeader,
          profile: this.profile,
          articalId: this.articalId
        }
      } else {
        this.dialogConfig.data = {
          title: 'Preview : ' + articalForm.articalTital,
          isEdit: isEdit,
          actionBtnText: 'บันทึกและเผยแพร่',
          cancleBtnText: 'ย้อนกลับ',
          customStyle: 'min-width: 650px;',
          articalForm: articalForm,
          havePoll: this.havePoll,
          pollForm: pollForm,
          articalHeader: this.articalHeader,
          profile: this.profile,
          articalId: this.articalId
        }
      }


      const formDialog = this.matDialog.open(ModalArticalPreviewComponent, this.dialogConfig);
      formDialog.afterClosed().subscribe()
    }
  }

  onFileSelected(e, articalForm) {
    const fileType = this.gobalFunctionService.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {
        this.coverName = e.target.files[0].name;

        const file = (e.target as HTMLInputElement).files[0];
        articalForm.patchValue({
          articalCover: file
        });
        articalForm.get('articalCover').updateValueAndValidity()

        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event) => {
          var file = new File([reader.result], <any>reader.result);
          this.articalHeader = file.name;
        }
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับแค่ไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  delete(id) {
    this.dialogConfig.disableClose = true;
    this.dialogConfig.id = 'modalDeleteArtical';
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.data = {
      title: 'คุณต้องการลบบทความ?',
      description: 'คุณต้องการลบบทความนี้? เมื่อลบแล้วผู้ใช้งานจะไม่สามารถเห็นบทความนี้ได้',
      actionBtnText: 'ลบ',
      cancleBtnText: 'ย้อนกลับ',
      isDelete: true
    }

    const formDialog = this.matDialog.open(ModalComponent, this.dialogConfig);
    formDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          const body = {
            ARTICAL_ID: id
          }
          return this.articalManagementService.deleteArticalById(body).pipe(
            switchMap(res => {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.id = 'modalConfirm';
              dialogConfig.width = '350px';
              dialogConfig.data = {
                title: 'สำเร็จ',
                description: '<img src="../../../assets/check.png" width="100px;" class="img-center">ลบบทความสำเร็จแล้ว',
                cancleBtnText: 'ยืนยัน',
              }
              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed();
            }),
            map(res => {
              if (!res) {
                window.opener.location.reload();
                setTimeout(() => {
                  window.close()
                }, 10);
              }
            })
          )
        }
        return of(false)
      })
    ).subscribe()
  }

  clearValueArticalDate(articalForm) {
    if (!articalForm['articalAlwaysOpen'].value) {
      articalForm.controls['articalDate'].setValue(null);
    }
  }

  getAllLearning() {
    this.learningCenterService.getAllLearningCenterAdmin().subscribe(
      res => {
        res.result.forEach(e => {
          this.allLearningCenter.push({
            CENTER_NAME: e.CENTER_NAME,
            CENTER_ID: e.CENTER_ID,
          })
        })
      });
  }

  patchLearning(val, form) {
    let value = [];
    value = val.value;
    // console.log(val.value);
    form.patchValue({
      centerId: value
    });
    form.get('centerId').updateValueAndValidity();
    // console.log(form.value.centerId);
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.CENTER_ID === i2.CENTER_ID : i1 === i2;
  }
}
